import React, { useEffect, useState } from "react";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import CloseIcon from "@mui/icons-material/Close";
import InputField from "../../../common/CustomInputField";
import SelectField from "../../../common/SelectField";
import RadioButton from "../../../common/RadioButton";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import "../../../common/styles/common.scss";
import { relationships } from "../../../constants/constants";
import { SecondaryButton } from "../../../common/Buttons";
import { Button } from "@mui/material";
import "../../../components/yourAssets/FT/familyTree.scss";
import { style } from "../../../common/common";
import toast, { Toaster } from "react-hot-toast";
import {
  addNewFamilyMember,
  getFamilyMembersList,
  setFamilyMembersList,
  updateFamilyMember,
} from "../../../utils/FTUtilities";
import {
  addFamilyMember,
  getMarriageTypes,
  uploadProfilePicture,
} from "../../../services/yourAssets/FamilyTreeServices";
import { Oval } from "react-loader-spinner";
import TextField from "../../../common/TextField";
import { useTranslation } from "react-i18next";
import { getKeyFromText } from "../../../utils/Utilities";

const AddMemberModal = (props) => {
  const {
    open,
    handleClose,
    currentNode,
    refreshTree,
    defaultValue,
    enableSelection,
    userId,
  } = props;

  const { t } = useTranslation();
  const [btnLoader, setBtnLoader] = useState(false);
  const [complicatedRelation, setComplicatedRelation] = useState(false);
  const [initialValues, setInitialValues] = useState({});
  const [profilePicture, setProfilePicture] = useState("");
  const [profilePictureName, setProfilePictureName] = useState("");
  const [marriageContractTypes, setMarriageContractTypes] = useState([]);
  const [partnersList, setPartnersList] = useState([]);
  const [firstNameError, setFirstNameError] = useState("");
  const [parentError, setParentError] = useState("");
  const containsNumber = (str) => {
    return /\d/.test(str);
  };
  const containSpecialChar = (str) => {
    return /[-!$%^&*()£_+|~=`{}\[\]:\/;<>?,.@#]/.test(str);
  };

  const modalSchema = Yup.object().shape({
    firstName: Yup.string()
      .label("First Name")
      .required(t("required"))
      .max(20, t("first-name-max"))
      .min(3, t("first-name-min"))
      .test(
        "First Name",
        t("first-name-invalid"),
        (value) => !containsNumber(value)
      ),
    lastName: Yup.string()
      .label("Last Name")
      .required(t("required"))
      .max(20, t("last-name-max"))
      .min(3, t("last-name-min"))
      .test(
        "Last Name",
        t("last-name-invalid"),
        (value) => !containsNumber(value)
      ),
    // isNotPet: Yup.boolean(),
    dateOfBirth: Yup.string().label("Date of birth"),
    // .when("isNotPet", {
    //   is: true,
    //   then: Yup.string().required(t("required")),
    // }),
    address: Yup.string()
      .label("Address")
      .max(50, t("address-max-50"))
      .min(3, t("address-min")),
    address: Yup.string().label("Note"),
  });
  useEffect(() => {
    let nodeList = getFamilyMembersList();

    let initialValues = {
      firstName: "",
      lastName: currentNode?.name === t("pet") ? t("pet") : "",
      relationship:
        Object.keys(currentNode).length > 0 ? currentNode : defaultValue,
      parent: {},
      dateOfBirth: "",
      personPassedAway: false,
      address: "",
      personLives: false,
      profilePicture: "",
      marriageContract: "",
      note: "",
      // isNotPet:
      //   currentNode?.relationship === "Pet" ||
      //   currentNode?.name === "Pet" ||
      //   currentNode?.name === "Haustier"
      //     ? false
      //     : true,
    };

    let array = [];
    let rootNode = nodeList[0];

    for (let i = 0; i < rootNode?.pids?.length; i++) {
      const elementI = rootNode?.pids[i];
      for (let i = 0; i < nodeList.length; i++) {
        const elementJ = nodeList[i];
        if (elementI === elementJ.id) {
          array.push(elementJ);
        }
      }
    }

    setPartnersList(array);
    setInitialValues(initialValues);

    const getMarriageTypeList = async () => {
      let result = await getMarriageTypes();

      if (result?.success) {
        setMarriageContractTypes([...result?.payLoad]);
      }
    };
    getMarriageTypeList();
  }, [currentNode, defaultValue]);

  const handleChange = (event, key, formik) => {
    let value;
    if (["relationship", "parent", "marriageType"].includes(key)) {
      value = event;
    } else if (key === "profilePicture") {
      value = event.target.files[0];
    } else {
      value = event.target.value || "";
    }
    if (key === "firstName") {
      formik.setFieldValue("firstName", value);
    } else if (key === "lastName") {
      formik.setFieldValue("lastName", value);
    } else if (key === "relationship") {
      formik.setFieldValue("relationship", value);
    } else if (key === "parent") {
      formik.setFieldValue("parent", value);
    } else if (key === "dateOfBirth") {
      formik.setFieldValue("dateOfBirth", value);
    } else if (key === "personPassedAway") {
      formik.setFieldValue("personPassedAway", !formik.values.personPassedAway);
    } else if (key === "address") {
      formik.setFieldValue("address", value);
    } else if (key === "personLives") {
      formik.setFieldValue("personLives", !formik.values.personLives);
    } else if (key === "profilePicture") {
      formik.setFieldValue("profilePicture", value);
    } else if (key === "marriageType") {
      formik.setFieldValue("marriageContract", value);
    } else if (key === "note") {
      formik.setFieldValue("note", value);
    }
    setParentError("");
    setFirstNameError("");
  };

  const handleSubmit = async (values) => {
    let nodeList = getFamilyMembersList();

    let pictureId = "";
    let pictureName = "";

    let maxId = Math.max(...nodeList.map((item) => item.id));
    let {
      firstName,
      lastName,
      personPassedAway,
      address,
      personLives,
      dateOfBirth,
      relationship,
      parent,
      marriageContract,
      note,
    } = values;

    if (Object.keys(relationship).length > 0) {
      let newObj = {
        id: maxId + 1,
        firstName,
        lastName,
        pictureId,
        pictureName,
        relationship: t(getKeyFromText(relationship.name)),
        marriageTypeId: marriageContract.id,
        gender:
          relationship.gender === "other" ? "female" : relationship.gender,
        edit: "/assets/icons/edit.png",
        addNew: "/assets/icons/plus.png",
        address,
        personLives,
        dateOfBirth,
        complicatedRelation,
        note: note,
      };

      setBtnLoader(true);
      if (personPassedAway) {
        newObj.isAliveImage = "/assets/icons/cross.png";
      }
      newObj.isDead = personPassedAway;

      let rootNode = nodeList[0];
      let dispatcherObj = {
        newObj,
        currentNodeId: rootNode.id,
      };
      if (["Son", "Daughter"].includes(relationship?.name)) {
        if (parent.gender === "female") {
          newObj.mid = parent.id;
        } else {
          newObj.fid = parent.id;
        }
        if (rootNode.gender === "female" || rootNode.gender === "other") {
          newObj.mid = rootNode.id;
        } else {
          newObj.fid = rootNode.id;
        }
        dispatcherObj.type = "childrelation";
      } else if (relationship.name?.includes("Partner")) {
        newObj.pids = [rootNode.id];
        if (relationship.name?.includes("Ex")) {
          newObj.divorced = [rootNode.id];
        }
        dispatcherObj.type = "addpartner";
      } else if (["Father", "Mother"].includes(relationship?.name)) {
        dispatcherObj.type = "addparent";
      } else if (["Brother", "Sister"].includes(relationship?.name)) {
        dispatcherObj.type = "addsiblings";
      }
      if (firstName) {
        if (
          ["Son", "Daughter"].includes(relationship?.name) &&
          Object.keys(parent).length === 0 &&
          partnersList.length > 0
        ) {
          setParentError("Required");
        } else {
          if (
            (rootNode?.pids.length === 0 &&
              ["Son", "Daughter"].includes(relationship?.name)) ||
            (rootNode?.mid &&
              rootNode?.fid &&
              rootNode?.id === 1 &&
              ["Father", "Mother"].includes(relationship?.name)) ||
            (rootNode?.fid === null &&
              rootNode?.mid === null &&
              ["Brother", "Sister"].includes(relationship?.name))
          ) {
            toast.error(t("cannot-add"));
          } else {
            if (profilePicture) {
              let formData = new FormData();
              formData.append("FamilyTreeImage", profilePicture);

              let result = await uploadProfilePicture(userId, formData);
              if (result?.success) {
                newObj.pictureId = result?.payLoad?.familyTreeImageId;
                newObj.pictureName = result?.payLoad?.originalFilename;
                // toast.success(t(getKeyFromText(result?.message)));
                addNewFamilyMember(newObj);
                updateFamilyMember(dispatcherObj);
                setFamilyMembersList(nodeList);
                setProfilePictureName("");
                setProfilePicture("");
                await addFamilyMember(userId, nodeList);
                handleClose();
                setBtnLoader(false);
                refreshTree();
              } else {
                toast.error(
                  t(getKeyFromText(result?.message).replaceAll(".", ""))
                );
                setBtnLoader(false);
              }
            } else {
              addNewFamilyMember(newObj);
              updateFamilyMember(dispatcherObj);
              setFamilyMembersList(nodeList);
              setProfilePictureName("");
              setProfilePicture("");
              await addFamilyMember(userId, nodeList);
              handleClose();
              setBtnLoader(false);
              refreshTree();
            }
          }
        }
      } else {
        setFirstNameError("Required");
      }
    }
  };

  const selectProfilePicture = (e) => {
    let file = e.target.files[0];
    setProfilePicture(file);
    setProfilePictureName(file.name);
  };

  const handleComplicatedRelation = () => {
    setComplicatedRelation(!complicatedRelation);
  };

  return (
    <>
      <Toaster />
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        closeAfterTransition
        BackdropComponent={Backdrop}
        className="add-member"
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Formik
          validationSchema={modalSchema}
          initialValues={initialValues}
          onSubmit={(values) => {
            !btnLoader && handleSubmit(values);
          }}
          enableReinitialize
        >
          {(formik) => {
            return (
              <Form>
                <Fade in={open}>
                  <Box sx={style}>
                    <Box
                      component="div"
                      className="header"
                      display="flex"
                      alignItems="center"
                      justifyContent="space-between"
                      padding="0px 10px"
                    >
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <div
                          style={{
                            height: "30px",
                            width: "30px",
                            marginRight: "10px",
                          }}
                        >
                          <img
                            src={`/assets/icons/${currentNode?.image}`}
                            alt="member"
                            width="100%"
                            height="100%"
                            style={{ marginTop: "2px", borderRadius: "50%" }}
                          />
                        </div>
                        <p>{currentNode?.name}</p>
                      </div>
                      <div style={{ display: "flex", alignItems: "center" }}>
                        {/* <DeleteOutlineIcon /> */}
                        <CloseIcon
                          onClick={handleClose}
                          sx={{ cursor: "pointer" }}
                        />
                      </div>
                    </Box>
                    <Box padding="0px 10px" sx={{ marginBottom: "20px" }}>
                      <TextField
                        label={t("input-1")}
                        value={formik.values.firstName}
                        onChange={(e) => {
                          handleChange(e, "firstName", formik);
                        }}
                        name="firstName"
                        error={
                          formik.errors.firstName && formik.touched.firstName
                            ? formik.errors.firstName
                            : ""
                        }
                      />
                      {initialValues.relationship.name !== t("pet") && (
                        <TextField
                          label={t("input-10")}
                          value={formik.values.lastName}
                          onChange={(e) => {
                            handleChange(e, "lastName", formik);
                          }}
                          name="lastName"
                          error={
                            formik.errors.lastName && formik.touched.lastName
                              ? formik.errors.lastName
                              : ""
                          }
                        />
                      )}

                      {initialValues.relationship.name !== t("pet") &&
                        initialValues.relationship.name !== t("friend") && (
                          <SelectField
                            label={t("input-15")}
                            defaultValue={defaultValue}
                            value={formik.values?.relationship?.name || ""}
                            onChange={(item) => {
                              handleChange(item, "relationship", formik);
                            }}
                            menuList={relationships}
                            enableSelection={enableSelection}
                            error={formik.errors}
                          />
                        )}
                      {["Son", "Daughter"].includes(defaultValue?.name) &&
                        partnersList?.length > 0 && (
                          <SelectField
                            label={t("input-16")}
                            value={formik.values?.parent?.firstName || ""}
                            onChange={(item) => {
                              handleChange(item, "parent", formik);
                            }}
                            menuList={partnersList}
                            error={formik.errors}
                          />
                        )}
                      {parentError && (
                        <p
                          style={{
                            fontSize: "10px",
                            color: "red",
                            margin: 0,
                          }}
                        >
                          {parentError}
                        </p>
                      )}
                      {["Partner-Male", "Partner-Female"].includes(
                        formik.values.relationship?.name
                      ) && (
                        <SelectField
                          label={t("marriage-contract-type")}
                          value={
                            t(
                              formik.values?.marriageContract?.translationKey
                            ) || ""
                          }
                          onChange={(item) => {
                            handleChange(item, "marriageType", formik);
                          }}
                          menuList={marriageContractTypes}
                          error={formik.errors}
                        />
                      )}

                      <InputField
                        label={t("input-2")}
                        type="date"
                        value={formik.values.dateOfBirth}
                        onChange={(newValue) => {
                          formik.setFieldValue("dateOfBirth", newValue);
                        }}
                        name="dateOfBirth"
                        error={
                          formik.errors.dateOfBirth &&
                          formik.touched.dateOfBirth
                            ? formik.errors.dateOfBirth
                            : ""
                        }
                      />
                      {initialValues.relationship.name !== t("pet") && (
                        <RadioButton
                          name="personPassedAway"
                          id={1}
                          label={t("passed-away-txt")}
                          value={1}
                          checked={formik.values.personPassedAway}
                          onChange={(e) => {
                            handleChange(e, "personPassedAway", formik);
                          }}
                        />
                      )}
                      {initialValues.relationship.name !== t("pet") && (
                        <TextField
                          label={t("input-12")}
                          value={formik.values.address}
                          onChange={(e) => {
                            handleChange(e, "address", formik);
                          }}
                          name="address"
                          error={
                            formik.errors.address && formik.touched.address
                              ? formik.errors.address
                              : ""
                          }
                        />
                      )}
                      {initialValues.relationship.name !== t("pet") && (
                        <RadioButton
                          name="personLives"
                          id={2}
                          label={t("live-withYou-txt")}
                          value={2}
                          checked={formik.values.personLives}
                          onChange={(e) => {
                            handleChange(e, "personLives", formik);
                          }}
                        />
                      )}

                      <InputField
                        label={t("input-18")}
                        onChange={selectProfilePicture}
                        name="profilePicture"
                        type="file"
                        docName={profilePictureName}
                        accept="image/png, image/gif, image/jpeg"
                      />
                      {initialValues.relationship.name !== t("pet") &&
                        initialValues.relationship.name !== t("friend") && (
                          <div
                            style={{
                              width: "100%",
                              backgroundColor: complicatedRelation
                                ? "#957ba0"
                                : "#DEDEDE",
                              borderRadius: "25px",
                              padding: "5px 0px ",
                              textAlign: "center",
                              marginTop: "10px",
                              color: complicatedRelation ? "#fff" : "#707070",
                            }}
                          >
                            <p
                              style={{
                                cursor: "pointer",
                              }}
                              onClick={handleComplicatedRelation}
                              dangerouslySetInnerHTML={{
                                __html: t("input-14"),
                              }}
                            ></p>
                          </div>
                        )}
                      {initialValues.relationship.name === t("pet") && (
                        <InputField
                          name="note"
                          label={t("input-17")}
                          type="textarea"
                          value={formik.values.note}
                          onChange={(e) => {
                            handleChange(e, "note", formik);
                          }}
                        />
                      )}
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          marginTop: "10px",
                        }}
                      >
                        <SecondaryButton
                          type="submit"
                          title={t("save")}
                          bgColor="color.magentaLight2"
                          borderRadius="20px"
                          border="1px solid #dfc8db"
                          width="100px"
                          // marginLeft="20px"
                          click={formik.handleSubmit}
                          isLoading={btnLoader}
                          textTransform="capitalize"
                        />
                      </div>
                    </Box>
                  </Box>
                </Fade>
              </Form>
            );
          }}
        </Formik>
      </Modal>
    </>
  );
};

export default AddMemberModal;
